import { render, staticRenderFns } from "./EditPermissions.vue?vue&type=template&id=33abe0b6&scoped=true&"
import script from "./EditPermissions.vue?vue&type=script&lang=js&"
export * from "./EditPermissions.vue?vue&type=script&lang=js&"
import style0 from "./EditPermissions.vue?vue&type=style&index=0&id=33abe0b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33abe0b6",
  null
  
)

export default component.exports